import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-vacation-mode';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Vacation Mode - Poshmark Sellers Guide</title>
        <meta name='description' content='Take a breather and learn how to pause your business while you are away!' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-vacation-mode' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-vacation-mode' />
        <meta property='og:title' content='Poshmark Vacation Mode - Poshmark Sellers Guide' />
        <meta
          property='og:description'
          content='Take a breather and learn how to pause your business while you are away!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
